import React from 'react'

const Withdraw = () => {
  return (
    <svg
      width="188"
      height="50"
      viewBox="0 0 188 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_343_1919)">
        <rect width="188" height="50" rx="25" fill="#33CC66" />
      </g>
      <path
        d="M66.36 32H63.22L59.3 18H62.2L64.88 28.38L67.8 18H70.16L73.1 28.38L75.78 18H78.68L74.76 32H71.62L68.98 22.76L66.36 32ZM81.0498 20.8C80.6232 20.8 80.2498 20.6467 79.9298 20.34C79.6232 20.02 79.4698 19.6467 79.4698 19.22C79.4698 18.7933 79.6232 18.42 79.9298 18.1C80.2498 17.78 80.6232 17.62 81.0498 17.62C81.4898 17.62 81.8632 17.78 82.1698 18.1C82.4898 18.42 82.6498 18.7933 82.6498 19.22C82.6498 19.6467 82.4898 20.02 82.1698 20.34C81.8632 20.6467 81.4898 20.8 81.0498 20.8ZM82.3498 32H79.7698V22H82.3498V32ZM90.4313 22V24.48H88.1713V28.64C88.1713 28.9867 88.2579 29.24 88.4313 29.4C88.6046 29.56 88.8579 29.6533 89.1913 29.68C89.5246 29.6933 89.9379 29.6867 90.4313 29.66V32C88.6846 32.2 87.4379 32.04 86.6913 31.52C85.9579 30.9867 85.5913 30.0267 85.5913 28.64V24.48H83.8513V22H85.5913V19.98L88.1713 19.2V22H90.4313ZM97.8103 21.72C98.917 21.72 99.817 22.0867 100.51 22.82C101.23 23.5667 101.59 24.58 101.59 25.86V32H99.0103V26.18C99.0103 25.5267 98.8303 25.02 98.4703 24.66C98.1236 24.3 97.6436 24.12 97.0303 24.12C96.3503 24.12 95.8103 24.3333 95.4103 24.76C95.0236 25.1733 94.8303 25.7867 94.8303 26.6V32H92.2503V18H94.8303V23.12C95.4436 22.1867 96.437 21.72 97.8103 21.72ZM111.373 23.18V18H113.953V32H111.373V30.82C110.613 31.7933 109.533 32.28 108.133 32.28C106.787 32.28 105.633 31.7733 104.673 30.76C103.727 29.7333 103.253 28.48 103.253 27C103.253 25.5333 103.727 24.2867 104.673 23.26C105.633 22.2333 106.787 21.72 108.133 21.72C109.533 21.72 110.613 22.2067 111.373 23.18ZM106.613 29.04C107.16 29.56 107.827 29.82 108.613 29.82C109.413 29.82 110.073 29.56 110.593 29.04C111.113 28.5067 111.373 27.8267 111.373 27C111.373 26.1733 111.113 25.5 110.593 24.98C110.073 24.4467 109.413 24.18 108.613 24.18C107.813 24.18 107.147 24.4467 106.613 24.98C106.093 25.5 105.833 26.1733 105.833 27C105.833 27.8267 106.093 28.5067 106.613 29.04ZM118.893 22V23.72C119.119 23.0933 119.506 22.62 120.053 22.3C120.599 21.9667 121.226 21.8 121.933 21.8V24.68C121.146 24.5733 120.439 24.7333 119.813 25.16C119.199 25.5733 118.893 26.26 118.893 27.22V32H116.313V22H118.893ZM130.671 23.18V22H133.251V32H130.671V30.82C129.897 31.7933 128.811 32.28 127.411 32.28C126.077 32.28 124.931 31.7733 123.971 30.76C123.024 29.7333 122.551 28.48 122.551 27C122.551 25.5333 123.024 24.2867 123.971 23.26C124.931 22.2333 126.077 21.72 127.411 21.72C128.811 21.72 129.897 22.2067 130.671 23.18ZM125.911 29.04C126.431 29.56 127.091 29.82 127.891 29.82C128.691 29.82 129.351 29.56 129.871 29.04C130.404 28.5067 130.671 27.8267 130.671 27C130.671 26.1733 130.404 25.5 129.871 24.98C129.351 24.4467 128.691 24.18 127.891 24.18C127.091 24.18 126.431 24.4467 125.911 24.98C125.391 25.5 125.131 26.1733 125.131 27C125.131 27.8267 125.391 28.5067 125.911 29.04ZM145.15 28.16L146.85 22H149.59L146.41 32H143.95L142.11 25.94L140.27 32H137.81L134.63 22H137.37L139.07 28.14L140.89 22H143.33L145.15 28.16Z"
        fill="white"
      />
      <path
        d="M26 40C17.72 40 11 33.28 11 25C11 16.72 17.72 10 26 10C34.28 10 41 16.72 41 25C41 33.28 34.28 40 26 40ZM24.5 25L24.5 31L27.5 31L27.5 25L32 25L26 19L20 25L24.5 25Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_b_343_1919"
          x="-7.6"
          y="-7.6"
          width="203.2"
          height="65.2"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="3.8" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_343_1919"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_343_1919"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default Withdraw
